module.exports = __webpack_public_path__ + "img/aboutus_bg.8d4af917.png";